module.exports = __webpack_public_path__ + "static/media/OOC_VS_BnH_P.07f5851c.png";


//////////////////
// WEBPACK FOOTER
// ./src/images/OOC_VS_BnH_P.png
// module id = 95
// module chunks = 0